import { Capability, FeatureFlag } from '__types__';

/** Enterprise pilot: show full design nav; individual routes may 404 until wired. */
export function enterpriseSidebarShowAll(
  _flag: FeatureFlag | null = null,
  _capability: Capability | null = null,
  _capabilitiesAtLeastOne: Capability[] | null = null
): boolean {
  return true;
}
